/**
 * 首字母大写
 */

function firstUpperCase(s) {
    if (s && s.length) {
        s = s[0].toUpperCase() + s.substr(1);
    }
    return s
}

export default firstUpperCase
